<mat-toolbar [ngClass]="message.cssClass" *ngIf="message">
  <span>{{ message.text }}</span>
</mat-toolbar>
